import React from 'react';
import styles from "./styles.module.css";
import Tooltip from '@mui/material/Tooltip';
import infoIcon from './../images/circle-info-regular-full.svg'; // adjust path if needed


function MostRecentStatusFirstDateSeen({ mostRecentStatusFirstDateSeenFilter, setMostRecentStatusFirstDateSeenFilter }) {
    const today = new Date();
    const maxDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    const handleStartDateChange = (e) => {
        setMostRecentStatusFirstDateSeenFilter({ startDate: e.target.value, endDate: mostRecentStatusFirstDateSeenFilter.endDate });
    };

    const handleEndDateChange = (e) => {
        setMostRecentStatusFirstDateSeenFilter({ startDate: mostRecentStatusFirstDateSeenFilter.startDate, endDate: e.target.value });
    };

    return (
        <section>
            <div className={styles.sectionTitleWithIcon}>
        <h1 className={styles.MostRecentStatusFirstDateSeenTitle}>
          Most recent status first date seen
        </h1>
        <Tooltip
          title="Filter by the first date a property’s most recent status was observed in the dataset. Select a start and/or end date to refine results."
          arrow
          placement="top"
          slotProps={{
            popper: {
              sx: {
                "& .MuiTooltip-tooltip": {
                  maxWidth: 500,
                  fontSize: "13px",
                  padding: "8px",
                },
              },
            },
          }}
        >
          <img
            src={infoIcon}
            alt="Most recent status first date seen info"
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>
            <div className={styles.MostRecentStatusFirstDateSeenDateInputContainer}>
                {/* Input for the start date */}
                <input
                    className={styles.MostRecentStatusFirstDateSeenStartDateInput}
                    type="date"
                    name="startDate"
                    max={maxDate}
                    value={mostRecentStatusFirstDateSeenFilter.startDate}
                    onChange={handleStartDateChange}
                    required
                />
                <span className={styles.MostRecentStatusFirstDateSeenDateLabel}>to</span>
                {/* Input for the end date */}
                <input
                    className={styles.MostRecentStatusFirstDateSeenEndDateInput}
                    type="date"
                    name="endDate"
                    max={maxDate}
                    value={mostRecentStatusFirstDateSeenFilter.endDate}
                    onChange={handleEndDateChange}
                    required
                />
            </div>
        </section>
    );
}

export default MostRecentStatusFirstDateSeen;
